import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import krTranslations from "../locales/ko_KR.json";
import usTranslations from "../locales/en_US.json";
import jpTranslations from "../locales/ja_JP.json";
import cnTranslations from "../locales/zh_CN.json";

const resources = {
  ko_KR: {
    translation: krTranslations,
  },
  en_US: {
    translation: usTranslations,
  },
  ja_JP: {
    translation: jpTranslations,
  },
  zh_CN: {
    translation: cnTranslations,
  },
};

const DEFAULT_LOCALE = "ko_KR";
const VALID_LOCALES = new Set(["ko_KR", "en_US", "ja_JP", "zh_CN"]);

const getInitialLocale = (): string => {
  if (typeof document === "undefined") return DEFAULT_LOCALE;
  const localeCookie = document.cookie
    .split(";")
    .find((c) => c.trim().startsWith("locale="));
  if (!localeCookie) return DEFAULT_LOCALE;
  const locale = decodeURIComponent(localeCookie.split("=")[1]);
  return VALID_LOCALES.has(locale) ? locale : DEFAULT_LOCALE;
};

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources,
    lng: getInitialLocale(),
    fallbackLng: DEFAULT_LOCALE,
    debug: false,
    interpolation: { escapeValue: false },
    returnObjects: true,
    returnEmptyString: true,
    returnNull: true,
    react: {
      useSuspense: false,
    },
  });
}

export default i18n;
